const SESSIONSCTRL = {
  clear (item){
    if(item){
      if(item.isArray){
        item.forEach((o)=>{
          localStorage.clear(o);
        });
      }else{
        localStorage.clear(item);
      }
    }else{
      localStorage.clear();
    }
  },
  set(key,val){
    localStorage.setItem(key, val);
  },
  get(key){
    return localStorage[key];
  }
};
export default SESSIONSCTRL;
